var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.highlights),function(obj){return _c('span',{class:{'badge badge-primary': obj.isHighlighted},staticStyle:{"white-space":"normal"}},[_vm._v(_vm._s(obj.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }